import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import axios from "axios";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ErrorModal from "../Security/ErrorModal";
import { useNavigate } from "react-router-dom";
import { Endpoints } from "../../Global/Endpoints";
import ChatBotWindow from "../ChatBot/ChatBotWindow";
import { useChat } from '../Layout/ChatContext';

export const Refills_Required = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const userInfo = useSelector((state) => state.userData);
    const [OrderType, setOrderType] = useState("");
    const [reviewData, setReviewData] = useState(null);
    const [selectedPharmacy, setSelectedPharmacy] = useState("");
    const [selectedPharmacyCode, setSelectedPharmacyCode] = useState("");
    const [selectedDate, setSelectedDate] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [showNurseModal, setShowNurseModal] = useState(false);
    const [triggerNurseModal, setTriggerNurseModal] = useState(false);
    const {isChatVisible, toggleChat, showChat } = useChat();
    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";
    const authNo = location.state?.authorizationDetail?.AuthNo;
    const initialPharmacyName = location.state?.authorizationDetail?.PharmacyName;
    const initialPharmacyCode=location.state?.authorizationDetail?.PharmacyID;

    useEffect(() => {

        // Set the initial selected pharmacy if provided in authorizationDetail
        if (initialPharmacyName) {
            setSelectedPharmacy(initialPharmacyName);
            setSelectedPharmacyCode(initialPharmacyCode);
        }

    const fetchReviewRXData = async () => {
        try {
            const params = {
                MemberID: userInfo.userData.MemberID,
                Contract: userInfo.userData.ContractIdentified,
                AuthNo: authNo,
                EmailID: userInfo.userData.EmailID,
                DeviceType: "PatientPortal",
            };
            
            const response = await axios.post(
                Endpoints.LoadReviewRX,
                { _Params: JSON.stringify(params) },
                {
                    //params: { _params: JSON.stringify(params) },
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": `Bearer ${localStorage.getItem('AccessToken')}`, // Adjust token source if necessary
                    }
                }
            );

            if (response.data) {
                setReviewData(response.data);
                setOrderType(response.data.OrderType);
                console.log("Review RX Data:", response.data);
            } else {
                console.error("Unexpected response structure:", response.data);
            }
        } catch (error) {
            console.error("Error fetching Review RX data:", error);
        }
    };

    fetchReviewRXData();
},  [authNo, initialPharmacyName, userInfo.userData.MemberID, userInfo.userData.ContractIdentified]);

const handleSubmit = async () => {
    if (!selectedDate) {
        setModalMessage("Please select date before submitting");
        setShowModal(true);
        return; 

    }  
      // Check if all required quantities have been entered and are valid
      const invalidQuantities = reviewData?.Rx?.some((drug) => {
        const quantity = requiredQuantities[drug.PresId];
        // Check if the quantity is missing, not a number, negative, not an integer, or exceeds BalanceQty
        return (
            !quantity ||
            isNaN(quantity) ||
            quantity < 0 ||
            !Number.isInteger(Number(quantity)) ||
            quantity > drug.BalanceQty ||
            /[^0-9]/.test(quantity) ||
            !/^\d+$/.test(quantity) // Ensure RequestedQty is not greater than BalanceQty
        );
    });

    if (invalidQuantities) {
        setModalMessage("Please enter valid quantities (non-negative integers that do not exceed the balance) for all required fields");
        setShowModal(true);
        return;
    }

    // Check if all required quantities have been entered
        const missingQuantities = reviewData?.Rx?.some((drug) => {
            const quantity = requiredQuantities[drug.PresId];
            return !quantity || quantity === ''; // Check if the value is missing or empty
        });

        if (missingQuantities) {
            setModalMessage("Please enter all required quantities before submitting");
            setShowModal(true);
            return;
        }
                // Function to format the date as MM/dd/yyyy
            const formatDate = (date) => {
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based, so add 1
                const day = String(date.getDate()).padStart(2, '0');
                const year = date.getFullYear();
                return `${month}/${day}/${year}`; // Use '/' as the separator for MM/dd/yyyy
            };

            // Format selectedDate with the custom function
            const formattedDate = formatDate(new Date(selectedDate));
    
    const requestData = {
        AuthNo: authNo,
        Contract: userInfo.userData.ContractIdentified,
        PharmCode: selectedPharmacyCode, 
        ScriptType: "Refill", 
        OrderType: OrderType, 
        Rx: reviewData?.Rx?.map((drug) => ({
            RequestedQty: drug.RequestedQty,
            HomeQty: requiredQuantities[drug.PresId],
            DrugName: drug.DrugName,
            PresId: drug.PresId,
            NDC: drug.NDC,
            BalanceQty: drug.BalanceQty,
        })),
        DateMedsNeeded: formattedDate, // Pass selected date
        MemberID: userInfo.userData.MemberID,
        EmailID: userInfo.userData.EmailID,
        DeviceType: "PatientPortal",
    };
    console.log("submitting",requestData);
    try {
        const response = await axios.post(
            Endpoints.SaveRxDrugRows,
            { _Params: JSON.stringify(requestData) },
            {
                //params: { _Params: JSON.stringify(requestData) },
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Authorization": `Bearer ${localStorage.getItem('AccessToken')}`,
                }
            }
        );

        if (response.data.Data) {
            // Optionally, you can redirect or show success message
            setModalMessage(
                isHighmarkPortal
                  ? "The Fertility and Family Building team will process this request and you will get another notification once this Rx request has been approved."
                  : "The WIN team will process this request and you will get another notification once this Rx request has been approved."
              );
              
                setShowModal(true);
                //setTimeout(() => setShowNurseModal(true), 2000);
                setTriggerNurseModal(true);
        } else {
            console.error("Error submitting data:", response.data);
        }
    } catch (error) {
        console.error("Error submitting data:", error);
    }
};
const handleNurseOkay = () => {
    navigate("/book-appointment"); // Adjust the route as needed
};

const handleModalClose = () => {
    setShowModal(false);
    if (triggerNurseModal) {
        setShowNurseModal(true);
        setTriggerNurseModal(false); // Reset the flag
    }
};

const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  const handleclosenurse=()=>{
    setShowNurseModal(false);
    navigate(-1);
  }

const [requiredQuantities, setRequiredQuantities] = useState({});

const handleRequiredQuantityChange = (presId, value) => {
    setRequiredQuantities((prev) => ({
        ...prev,
        [presId]: value, // Update required quantity for the specific prescription
    }));
 // Also update HomeQty with the same value
 setReviewData((prev) => ({
    ...prev,
    Rx: prev.Rx.map((drug) =>
        drug.PresId === presId
            ? { ...drug, HomeQty: value } // Update HomeQty with the new input value
            : drug
    ),
}));
}

    return(
        <>
            <div className="col-12 mt-4 inner-page-heading-wrapper">
                <button onClick={handleBackClick} className="win-back-btn"><span><i class='bi bi-chevron-left'></i>{t('Back')}</span></button>
                <h2 className="page-heading">{t('refillsRequired')}</h2>
            </div>
            <div className="col-md-4 mt-5">

                <div className="mb-3">
                    <label
                    htmlFor="date"
                    className="form-label win-form-label" // Add a class for better control
                    style={{ display: 'block' }} 
                    >
                    {t('selectMedicationsByDate')}
                    </label>
                    <DatePicker
                        selected={selectedDate}
                        dateFormat="MM/dd/yyyy"
                        className="form-control win-form-control mobile-view"
                        id="date"
                        onChange={(date) => {
                            setSelectedDate(date);  // Updates the state with the selected date
                            console.log("Selected Date:", date);  // Logs to verify the date
                        }}
                        placeholderText="MM/DD/YYYY"
                        showYearDropdown
                        scrollableYearDropdown
                        minDate={new Date()}
                        onKeyDown={(e) => e.preventDefault()} 
                    />
              </div>

              <p className="rx-refills-note">
              {t('refillQuantitiesInstructions')}
              </p>
        {/* Loop over the drugs array and render each drug's information dynamically */}
        {reviewData?.Rx?.map((drug) => (
          <div key={drug.PresId} className="rx-refills-required-wrapper">
            <h3 className="medicine-title">{drug.DrugName}</h3>

            <div className="quantity-block-wrapper">
              <div className="quantity-block">
                <div className="quantity-label">{t('remainingQty')}</div>
                <input
                                    type="number"
                                    className="form-control quantity-textbox"
                                    value={drug.BalanceQty || ""}
                                    readOnly
                                />
              </div>
              <div className="quantity-block">
                <div className="quantity-label">{t('requiredQty')}</div>
                <input
                                type="number"
                                className="form-control quantity-textbox"
                                value={requiredQuantities[drug.PresId] || ""}
                                onChange={(e) => handleRequiredQuantityChange(drug.PresId, e.target.value)}
                                min={0}
                            />
              </div>
            </div>
          </div>
        ))}
                <div className="mb-3 d-flex">                    
                    <button type="submit" className="win-btn-primary mt-4" onClick={handleSubmit}>{t('submit')}</button>
                </div>

            </div>
            <ErrorModal show={showModal} message={modalMessage} onClose={handleModalClose}  />
            <ErrorModal
                show={showNurseModal}
                onClose={handleclosenurse}
                showConfirmButtons={true}
                message={"Would you like to schedule a call with a nurse?"}
                onOkay={handleNurseOkay}
            />
            {/* {isChatVisible && <ChatBotWindow />} */}
        </>
    )
}

export default Refills_Required;